// Mirror of /app/backend/services/feature_catalog.py — KEEP IN SYNC.
// If you add / rename a feature, edit BOTH files.

export const FEATURES = [
  { id: "stimulus_library",    label: "Stimulus Library",     onboardingFirst: true,  inRatings: true },
  { id: "array_builder",       label: "Array Builder",        onboardingFirst: true,  inRatings: true },
  { id: "printable_materials", label: "Printable Materials",  onboardingFirst: true,  inRatings: true },
  { id: "sorting",             label: "Sorting",              onboardingFirst: true,  inRatings: true },
  { id: "token_board",         label: "Token Board",          onboardingFirst: true,  inRatings: true },
  { id: "clinic_libraries",    label: "Clinic Libraries",     onboardingFirst: true,  inRatings: true },
  { id: "team_sharing",        label: "Team Sharing",         onboardingFirst: true,  inRatings: true },
  { id: "ai_stimulus",         label: "AI Stimulus Creation", onboardingFirst: true,  inRatings: true },
  { id: "account_nav",         label: "Account / Navigation", onboardingFirst: false, inRatings: false },
  { id: "other",               label: "Other",                onboardingFirst: false, inRatings: false },
];

export const ONBOARDING_FIRST_FEATURES = FEATURES.filter((f) => f.onboardingFirst);
export const FEEDBACK_FEATURES = FEATURES; // all 10, including Account / Nav + Other
export const RATING_FEATURES = FEATURES.filter((f) => f.inRatings);
